import { OAUTH } from '../utils/constants.json';

const INITIAL_STATE = { isLogin: false };
/**
 * Reducer - to update oauth state
 * @param {Object} state initial/default oauth state.
 * @param {Object} action to be performed
 * @return {Object} new oauth state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case OAUTH.LOGIN:
      return { ...payload };
    case OAUTH.LOGOUT:
      return { isLogin: false };
    default:
      return state;
  }
}
